<template>
<transition v-on:enter="enter($event)">
<div class="internet" v-show="judge" :style="{ 'z-index': modaldata.Zindex, }" @click="stopDocument($event);">

  <transition name="slide-fade">
  <div class="internet-body" v-show="judgeBody">
    <div>
      目前作品已保存。但由于网络连接超时，暂时无法进行其他操作。网络恢复后可继续编辑作品。
    </div>
  </div>
  </transition>

</div>
</transition>
</template>

<script>
//  弹窗组件，所欲设置的弹窗组件
import Velocity from 'velocity-animate'
import modal    from '../mixins/modal'

export default {
  mixins: [modal],
  data() {
    return {
      modalName   : 'internet',
      judgeBody   : false,
    };
  },
  watch : {
    'boxData' : function(val, oldval){ // 判断打开关闭
      if (this.judge ) { // 打开的操作
       
      }
    },
  }, 
  mounted () {
  },
  methods: {
    enter: function (el, index) { // 打开动画
      Velocity(el, { }, {});
      Velocity(el, { }, { duration:  300, complete: ()=>{
        this.judgeBody = true;
      },});
    },
  },
  components: {
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .internet{
    .internet-body{
      width: 100%;
      height: 100%;
      background: -prefix-linear-gradient(top, rgba(211, 211, 212, 1) 10%, rgba(211, 211, 212, 0.6) 80%, rgba(211, 211, 212, 0.3));
      background: linear-gradient(to bottom, #040404 10%, rgba(0, 0, 0, 0.6) 80%, rgba(0, 0, 0, 0.3));

      >div{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 100%;
        height: 70px;
        border-radius: 5px;
        font-size: 14px;
        line-height: 70px;
        color: #fff;
        background: rgba(0, 0, 0, 0.47);
      }
    }
    
  }
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(-300px);
  opacity: 0;
}

</style>


// WEBPACK FOOTER //
// src/components/modal/isInternet.vue